import useRequest from '@gp/hooks/useRequest';
import { fetchUserPermissions } from '../utils/permissions';

export default function useReportAdminMode() {
  const { loading, data: userPermissions } = useRequest(fetchUserPermissions);

  const adminMode = userPermissions?.admin_mode === true;

  return { loading, adminMode };
}
